const colors = {
  primary: {
    main: '#13726E',
    hover: '#12625E',
    active: '#12625E',
  },
  secondary: {
    main: '#EAA52E',
    hover: '#DC8E07',
    active: '#DC8E07',
  },
  tertiary: {
    main: '#66D9A3',
    hover: '#5AD297',
    active: '#47C885',
  },
  quaternary: {
    main: '#E37222',
  },
  neutral: {
    primary: '#FFFFFF',
    secondary: '#000000',
    filter: '#000000',
    modal: '#000000',
  },
  grayscale: {
    dark: {
      title: '#ffffff',
      paragraph: '#ffffff',
      info: 'rgba(255, 255, 255, 0.6)',
      line: 'rgba(255, 255, 255, 0.2)',
    },
    light: {
      title: '#000000',
      paragraph: 'rgba(0, 0, 0, 0.75)',
      info: 'rgba(0, 0, 0, 0.5)',
      line: '',
    },
    nav: '#77787B',
    tab: {
      borderDisabled: '#C4C4C4',
      titleDisabled: 'rgba(0, 0, 0, 0.5)',
    },
    disabled: 'rgba(0, 0, 0, 0.2)',
    enabled: 'rgba(0, 0, 0, 0.5)',
  },
  background: {
    public: '#E8E8E8',
    private: '#E8E8E8',
    email: '#000000',
    dark: {
      input: '#000000',
      button: '#000000',
    },
    light: {
      input: '#FFFFFF',
      button: '#FFFFFF',
    },
    structure: {
      footer: '#000000',
      nav: '#000000',
      interactions: '#DCE0E2',
    },
  },
  contextual: {
    success: '#38cd3c',
    danger: '#ff0202',
    attention: '#fda700',
  },
}

export default colors
